import { Link } from "react-router-dom";
import { t } from "@/lib/i18n";

const SRC = { cream: "/brand/wordmark-cream.png", ink: "/brand/wordmark-ink.png" };

export const Wordmark = ({ onOlive = true, to = "/", sub = true, className = "" }) => (
  <Link to={to} className={`inline-flex items-baseline gap-2.5 ${onOlive ? "text-cream-50" : "text-olive-900"} ${className}`} data-testid="wordmark-link" aria-label="Patria Care + Counseling home">
    <img src={onOlive ? SRC.cream : SRC.ink} alt="Patria" className="h-5 w-auto sm:h-6" width="930" height="250" />
    {sub && <span className={`text-sm font-semibold opacity-90 whitespace-nowrap ${sub === "wide" ? "hidden 2xl:inline" : ""}`}>{t("brand.sub")}</span>}
  </Link>
);

export const BrandMark = ({ kind = "branch", tone = "ink", className = "" }) => (
  <img src={`/brand/${kind}-${tone}.png`} alt="" aria-hidden="true" className={className} />
);

export const ScriptMark = ({ tone = "jaffa", className = "" }) => (
  <img src={`/brand/script-${tone === "jaffa" ? "terracotta" : tone}.png`} alt="Patria" className={className} width="386" height="218" />
);

const LINE = { cream: "bg-cream-50/30", terracotta: "bg-terracotta-600/50", ink: "bg-sage-400/70" };

export const BranchDivider = ({ tone = "ink", centered = false, className = "" }) => (
  <div className={`flex items-center gap-5 ${className}`} role="separator" aria-hidden="true">
    {centered && <span className={`h-px flex-1 ${LINE[tone]}`} />}
    <img src={`/brand/branch-${tone}.png`} alt="" className={`h-8 w-auto ${tone === "terracotta" ? "" : "opacity-70"}`} />
    <span className={`h-px flex-1 ${LINE[tone]}`} />
  </div>
);
